import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Plan } from "@modules/plans/types";
import { PlanFormValues } from "@modules/plans/validations";
import { editPlanService } from "./service";
import { UseEditPlanMutationOptions } from "./types";

export function useEditPlanMutation(
  options?: UseEditPlanMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Plan, ApiError, { id: string; data: PlanFormValues }>({
    mutationFn: ({ id, data }) => editPlanService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("subscription_plan_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
